<template>
  <div class="px-6 py-6 space-y-6 container">
    <div class="space-y-6 w-full">
      <div class="p-4 border rounded-md space-y-3">
        <div class="flex items-center justify-between">
          <div class="space-y-1">
            <label for="miraIntegrationSwitch" class="text-sm text-primary font-medium">
              Mira Integration
            </label>
            <p class="text-xs text-mid-neutral-400">
              Enable Mira integration to allow users to purchase PDFs for review items
            </p>
          </div>
          <Switch
            id="miraIntegrationSwitch"
            :model-value="isMiraIntegrationEnabled"
            :disabled="loading.isLoading.value"
            @update:model-value="toggleMiraIntegration"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Switch from "@app/components/Global/Switch.vue";
import useLoading from "@app/composables/use-loading";
import useSnackbar from "@app/composables/use-snackbar";
import { injectStrict } from "@app/utils/injectStrict";
import { EvidenceServiceApiKey } from "@app/injectionKeys";
import { onMounted } from "vue";
import { useMiraIntegration } from "@app/composables/useMiraIntegration";

const evidenceService = injectStrict(EvidenceServiceApiKey);
const loading = useLoading();
const snackbar = useSnackbar();
const { isEnabled: isMiraIntegrationEnabled, load, setEnabled } = useMiraIntegration();

onMounted(async () => {
  await load();
});

async function toggleMiraIntegration(enabled: boolean | undefined) {
  if (enabled === undefined) return;
  loading.start();

  try {
    if (enabled) {
      await evidenceService.api.settingsControllerEnableMiraIntegration();
      snackbar.success("Mira integration enabled successfully");
    } else {
      await evidenceService.api.settingsControllerDisableMiraIntegration();
      snackbar.success("Mira integration disabled successfully");
    }
    setEnabled(enabled);
  } catch (error: any) {
    snackbar.error(error?.response?.data?.message || "Failed to update Mira integration");
  } finally {
    loading.stop();
  }
}
</script>
